var _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApexAnalyticsText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 60,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 45,
    fill: "#00B0A0",
    fontFamily: "Raleway, sans-serif",
    fontSize: 36,
    fontWeight: 300
  }, "\n        Apex Analytics\n    ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApexAnalyticsText);
export default __webpack_public_path__ + "static/media/apex-analytics-text.a65120c0ed4ef18d0653ebbf3f5f8b8a.svg";
export { ForwardRef as ReactComponent };